import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, Card, CardMedia, CardContent, Typography, Avatar, Box, Button } from '@mui/material';
import './ModalCard.css'

const ModelCard = ({ model }: { model: any }) => {
    const navigate = useNavigate();
    const formattedDate = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        timeZone: 'UTC',
    }).format(new Date(model.createdAt));
    const location = useLocation();
    const locationPath = location.pathname.startsWith('/personas')

    console.log("modelType", model.type);

    const handleNavigate = () => {
    if (locationPath) navigate(`/${model?.type === "Person" ? `humanpersona` : 'aipersona'}/model/${model._id}`, { state: { modelType: model.type } });
};


    return (
        <Card
            className="model-card"
            onClick={() => handleNavigate()}
        >
            <CardMedia
                component="img"
                alt={model.name}
                image={
                    model.sampleImage?.url ||
                    (model.type === "Person" ? '/assets/person_default.svg' : '/assets/product_default.svg')
                }
                className="modalCardMedia"
            />
            <CardContent className="modalCardContent">
                <Box className="modelCardHeader">
                    <Avatar
                        className="avatarModel"
                        src={
                            model.sampleImage?.url ||
                            (model.type === "Person" ? '/assets/person_default.svg' : '/assets/product_default.svg')
                        }
                        alt={model.name}
                    />
                    <Typography component="div" className="modelCardTitle">
                        {model.name}
                    </Typography>
                </Box>
                <Grid item xs={12} container className="modelCardFooter">
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Button className="type-button">
                        {model?.type === "AiInfluencer"
                            ? 'AI Persona'
                            : model?.type === "Person"
                                ? 'Human Persona'
                                : model?.type}
                                </Button>
                    {model?.training !== null && model.training?.trainingRequestStatus !== "" &&
                        <Button
  variant="contained"
  color={model.status === 'Trained' ? 'success' : 'primary'}
  className={`${model.training?.trainingRequestStatus === 'COMPLETED' ? 'trained-button' : 'type-button'}`}
>
  {model.training?.trainingRequestStatus
    .toLowerCase()
    .replace(/^\w/, (c: string) => c.toUpperCase())}
</Button>}
                    </Box>

                </Grid>
                <Typography variant="body2" className="modelCardDate">
                    Created On {formattedDate}
                </Typography>
            </CardContent>
        </Card>
    );
};
export default ModelCard;